import DirectusCombobox from "../combobox";
import FilterWrapper from "components/filter/wrapper";
import React from "react";
import client from "directus/src/client";
import { RenderProfile } from "components/render-profile";

export default function ClientCombobox({
  filter,
  hideLabel,
  className,
  ...props
}) {
  if (hideLabel) {
    return (
      <div className={className}>
        <DirectusCombobox
          client={client}
          collection="clients"
          fields={["id", "first_name", "last_name"]}
          searchKeys={["first_name", "last_name"]}
          mapItem={(item) => ({
            value: item.id,
            label: <RenderProfile user={item} />,
            select: <RenderProfile user={item} />,
          })}
          filter={filter}
          sort={["first_name", "last_name"]}
          placeholder="Select Client"
          {...props}
        />
      </div>
    );
  }
  return (
    <FilterWrapper label="Client" className={className}>
      <DirectusCombobox
        client={client}
        collection="clients"
        fields={["id", "first_name", "last_name"]}
        searchKeys={["first_name", "last_name"]}
        mapItem={(item) => ({
          value: item.id,
          label: <RenderProfile user={item} />,
          select: <RenderProfile user={item} />,
        })}
        filter={filter}
        sort={["first_name", "last_name"]}
        {...props}
      />
    </FilterWrapper>
  );
}
